import { render, staticRenderFns } from "./AttachmentCentreData.vue?vue&type=template&id=d7895d9c&scoped=true"
import script from "./AttachmentCentreData.vue?vue&type=script&lang=js"
export * from "./AttachmentCentreData.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCentreData.vue?vue&type=style&index=0&id=d7895d9c&prod&scoped=true&lang=css"
import style1 from "./AttachmentCentreData.vue?vue&type=style&index=1&id=d7895d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7895d9c",
  null
  
)

export default component.exports